import { IForm } from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'fillDate',
      type: 'default',
      label: '日期'
    },
    {
      field: 'empName',
      type: 'default',
      label: '姓名'
    },
    {
      field: 'introduceService',
      type: 'number',
      label: '介绍服务',
      maxLength: 4,
      placeholder: '请输入介绍服务次数',
      suffix: '次'
    },
    {
      field: 'quotedPrice',
      type: 'number',
      label: '报价',
      maxLength: 9,
      placeholder: '请输入报价次数',
      suffix: '次'
    },
    {
      field: 'replyRate',
      type: 'percent',
      label: '回复率',
      placeholder: '请输入回复率',
      suffix: '%'
    },
    {
      field: 'hundredThousandLiveData',
      type: 'number',
      label: '10万以上直播数据',
      maxLength: 6,
      placeholder: '请输入10万以上直播数据个数',
      suffix: '个'
    }
  ],
  colLayout: 24
}
